import { GET_DASHBOARD_COUNT, GET_DASHBOARD_SUBORDERS } from 'src/apiService/apiDeclaration';
import { Grid, Skeleton, Typography } from '@mui/material';
import { orderSectionIcons } from 'src/constants';
import StoreIcon from '@mui/icons-material/Store';
import { useEffect, useState } from 'react';
import OrderSectionCard from './OrderSectionCard';
import { t } from 'i18next';

const OrderSection = () => {
  const [ordersInfo, setOrdersInfo] = useState([]);

  const getdata = async () => {
    let resp;
    try {
      resp = await GET_DASHBOARD_SUBORDERS();
      const updatedData = resp.data.filter((item) => item._id !== 'IN_QUEUE');
      setOrdersInfo(updatedData);
      resp = await GET_DASHBOARD_COUNT();
      setOrdersInfo((prev) => [...resp.data.slice(0, 4), ...prev, resp.data[4]]);
    } catch (error) {
      console.log(error.message);
    }
  };

  const colors = [
    '#AA2B62',
    '#e5bd44',
    '#ff6e39',
    '#2c6fbb',
    '#46BE93',
    '#AB20FD',
    '#BE3144',
    '#355E95',
    '#4B5945',
    '#DA498D',
  ];

  const routing = {
    PENDING_REVIEW: { to: '/order', status: 'PENDING_REVIEW' },
    NEGOTIATION_SUCCESSFUL: { to: '/order', status: 'NEGOTIATION_SUCCESSFUL' },
    NEGOTIATION_FAILURE: { to: '/order', status: 'NEGOTIATION_FAILURE' },
    PAYMENT_RECEIVED: { to: '/order', status: 'PAYMENT_RECEIVED' },
    COMPLETED: { to: '/order', status: 'COMPLETED' },
    IN_PROGRESS: { to: '/sub-order', status: 'IN_PROGRESS' },
    DISPATCHED: { to: '/sub-order', status: 'DISPATCHED' },
    READY_FOR_DISPATCHED: { to: '/sub-order', status: 'READY_FOR_DISPATCHED' },
    PREPARING: { to: '/sub-order', status: 'PREPARING' },
    DELIVERED: { to: '/sub-order', status: 'DELIVERED' },
  };

  useEffect(() => {
    getdata();
  }, []);
  return (
    <>
      <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <StoreIcon sx={{ fontSize: '2.5rem', color: '#acd629' }} />
        <Typography variant="h4">{t('dashboard.orderSection')}</Typography>
      </Grid>
      <Grid container gap={{ sm: 3, xs: 1.5 }} sx={{ justifyContent: { md: 'start', xs: 'center' }, py: 2 }}>
        {ordersInfo[0]?._id === 'PENDING_REVIEW'
          ? ordersInfo.map((item, index) => {
              return (
                <OrderSectionCard
                  path={routing[item._id]}
                  key={index}
                  title={item._id}
                  value={item.count}
                  icon={orderSectionIcons[item._id].icon}
                  step={orderSectionIcons[item._id].step}
                  bgColor={colors[index]}
                />
              );
            })
          : Array(5)
              .fill(null)
              .map((_, index) => {
                return (
                  <Skeleton
                    key={index}
                    animation="wave"
                    sx={{ borderRadius: '12px' }}
                    variant="rectangular"
                    width={260}
                    height={140}
                  />
                );
              })}
      </Grid>
    </>
  );
};

export default OrderSection;
